import { ToastController } from "@ionic/angular";

export function randomlyChoseN(choicesArray: integer[], n: integer, rng: () => number = Math.random) {
  var selected = [];
  n = Math.min(choicesArray.length, n);
  for (var i = 0; i < n; i++) {
    selected.push(
      choicesArray.splice(rng() * (choicesArray.length - 1), 1).pop()
    );
  }
  return selected;
}

export function getVisibleBounds(cam: Phaser.Cameras.Scene2D.Camera) {
  const left: number = (cam.width / 2) * (1 - 1 / cam.zoom);
  const right: number = (cam.width / 2) * (1 + 1 / cam.zoom);
  const top: number = (cam.height / 2) * (1 - 1 / cam.zoom);
  const bottom: number = (cam.height / 2) * (1 + 1 / cam.zoom);
  return { top: top, bottom: bottom, left: left, right: right };
}

export async function showToast(config: {message: string, color?: string, url?: string, duration?: number, callback?: Function}) {
  const toastController = new ToastController();
  const toastOptions: any = {
    message: config.message,
    position: 'top',
    color: config.color ? config.color : 'primary',
    duration: config.duration !== undefined ? config.duration : 3000,
    buttons: []
  };

  if (toastOptions.duration === 0) {
    console.log("duration is 0, adding OK button to toast");
    toastOptions.buttons.push(
      {
        text: 'OK',
        role: 'cancel'
      }
    );
  }

  if (config.url) {
    toastOptions.buttons.push(
      {
        text: 'Open Link',
        handler: () => {
          window.open(config.url, '_blank');
        }
      }
    );
    // If you want the toast to stay until the user taps the button, set duration to 0
    // toastOptions.duration = 0;
  }

  const toast = await toastController.create(toastOptions);
  await toast.present();

  toast.onDidDismiss().then(() => {
    if( config.callback ){
      config.callback();
    }
  });

  return toast;
}

export const bounceGameObject = (gameObject: Phaser.GameObjects.Shape | Phaser.GameObjects.Image, infiniteRepeat=false) => {
  const originalScale = gameObject.scale;
  const bounceTween = gameObject.scene.tweens.add({
    targets: gameObject,
    scale: originalScale*1.3, // Increase size by 30%
    duration: 250,
    ease: 'Power2',
    yoyo: true,
    repeat: infiniteRepeat ? -1 : 5, // -1 means infinite repeats
    onComplete: () => {
      // Only needed for finite repeats
      if (!infiniteRepeat) {
        gameObject.setScale(originalScale);
      }
    }
  });
  bounceTween.play();
  return bounceTween; // Return the tween so it can be stopped later if needed
}